import React, { useContext, useEffect, useState, useMemo } from 'react';
import styles from './SubscriptionStatus.module.css';
import { fetchPaymentHistory, fetchSubscriptionUrl } from '../../../services';
import { dataContext } from '../../../App';
import { formatDateTime } from '../../Profile/ReferralHistory/dateFormatter';

const SubscriptionStatus = ({ isSubscribe, isSubscribeTournament, isSubscribeBcs, isSubscribeSports, setShowLoginModal, setShowOtpModal, setShowRefundModal }) => {
  const { token, playerData } = useContext(dataContext);
  const [dailyPayment, setDailyPayment] = useState({});
  const [sportsPayment, setSportsPayment] = useState({});
  const [tournamentPayment, setTournamentPayment] = useState({});
  const [bcsPayment, setBcsPayment] = useState({});

  useEffect(() => {
    fetchPaymentHistory(token).then((res) => {
      // Helper to get latest payment by service_type
      function getLatestPayment(serviceType) {
        console.log(serviceType,res)
        const filtered = res.filter(
          (item) => item.serviceType === serviceType
        );
        console.log(filtered)
        if (filtered.length === 0) return {};
        // Sort by payment_date descending
        filtered.sort(
          (a, b) => new Date(b.paymentDate) - new Date(a.paymentDate)
        );
        console.log(filtered)
        return filtered[0];
      }

      setDailyPayment(getLatestPayment("Daily"));
      setSportsPayment(getLatestPayment("Sports"));
      setTournamentPayment(getLatestPayment("Tournament"));
      setBcsPayment(getLatestPayment("BCS"));
    });
  }, [token]);

  function handleSubscriptionClick(service_type) {
    if (!playerData?.id) {
      setShowLoginModal(true);
      return;
    }
    fetchSubscriptionUrl(token, service_type)
      .then((res) => {
        setShowOtpModal(true);
      });
  }

  function handleUnSubscriptionClick(service_type) {
    sessionStorage.setItem('unsubsServiceType', service_type);
    setShowRefundModal(true);
  }

  // Create subscription data array
  const subscriptionData = useMemo(() => [
    {
      id: 'daily',
      type: 'Daily',
      title: 'কুইজ প্রতিদিন সাবস্ক্রিপশন',
      background: '#12793C',
      isSubscribed: isSubscribe,
      payment: dailyPayment,
      feature: 'প্রতিদিন ২ রাউন্ড কুইজ প্রতিদিন'
    },
    {
      id: 'tournament',
      type: 'Tournament',
      title: 'টুর্নামেন্ট সাবস্ক্রিপশন',
      background: '#0081DC',
      isSubscribed: isSubscribeTournament,
      payment: tournamentPayment,
      feature: 'সকল টুর্নামেন্টে অংশগ্রহণ'
    },
    {
      id: 'sports',
      type: 'Sports',
      title: 'স্পোর্টস সাবস্ক্রিপশন',
      background: '#008080',
      isSubscribed: isSubscribeSports,
      payment: sportsPayment,
      feature: 'সকল স্পোর্টস কুইজে অংশগ্রহণ'
    },
    {
      id: 'bcs',
      type: 'BCS',
      title: 'বিসিএস সাবস্ক্রিপশন',
      background: '#b54a8b',
      isSubscribed: isSubscribeBcs,
      payment: bcsPayment,
      feature: 'প্রতিদিন ২ রাউন্ড বিসিএস কুইজ'
    }
  ], [
    isSubscribe, isSubscribeTournament, isSubscribeSports, isSubscribeBcs,
    dailyPayment, tournamentPayment, sportsPayment, bcsPayment
  ]);

  // Sort subscriptions: subscribed first, then unsubscribed
  const sortedSubscriptions = useMemo(() => 
    [...subscriptionData].sort((a, b) => {
      if (a.isSubscribed && !b.isSubscribed) return -1;
      if (!a.isSubscribed && b.isSubscribed) return 1;
      return 0;
    }), 
  [subscriptionData]);

  return (
    <div className={styles.subscriptionContainer}>
      <h2 className={styles.title}>সাবস্ক্রিপশন</h2>
      
      {sortedSubscriptions.map((subscription, index) => (
        <div 
          key={subscription.id} 
          className={styles.subscriptionBox} 
          style={index === sortedSubscriptions.length - 1 ? {marginBottom: '0px'} : {}}
        >
          <div className={styles.header}>
            <span className={styles.type} style={{background: subscription.background}}>
              {subscription.title}
            </span>
            {subscription.isSubscribed && <span className={styles.badge}>সাবস্ক্রাইবড</span>}
          </div>
          
          <div className={styles.price}>
            <span className={styles.amount}>৳৩০</span>
            <span className={styles.duration}>ট্যাক্স সহ ৭ দিনের জন্য</span>
            <br></br><span>**অটো রিনিউয়াল প্রযোজ্য</span>
            {subscription.isSubscribed && subscription.payment?.paymentDate && (
              <>
                <br /><span style={{fontSize:'14px'}}>Payment Date: {formatDateTime(subscription.payment.paymentDate)}</span>
                <br /><span style={{fontSize:'14px'}}>Next Payment Date: {formatDateTime(subscription.payment.nextPaymentDate)}</span>
              </>
            )}
          </div>

          <div className={styles.features}>
            <div className={styles.feature}>{subscription.feature}</div>
          </div>
          
          {!subscription.isSubscribed && (
            <button 
              className={styles.subscribeButton} 
              onClick={() => handleSubscriptionClick(subscription.type)}
            >
              সাবস্ক্রাইব করুন
            </button>
          )}
          
          {subscription.isSubscribed && (
            <button 
              className={styles.unsubscribeButton} 
              onClick={() => handleUnSubscriptionClick(subscription.type)}
            >
              আনসাবস্ক্রাইব করুন
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default SubscriptionStatus;
